<template>

<table class="table">

    <slot></slot>

</table>

</template>

<script>

export default {

}

</script>

<style scoped>

.table {
	width: 100%;
}

.table td,
.table th {
	text-align: left;
	font-size: 14px;
	font-weight: 400;
	vertical-align: middle;
	padding: 15px 10px;
	border-bottom: 1px solid #00000033;
	position: relative;
}

.table th {
	color: #005EB8;
	border-bottom: 2px solid #00000033;
}

.table tbody tr:hover td {
	background-color: #eef4ff;
}

.table td[align="center"],
.table th[align="center"] {
	text-align: center;
}

.table td:first-child,
.table th:first-child {
	padding-left: 40px;
}

.table td:last-child,
.table th:last-child {
	padding-right: 40px;
}

.table td small {
	font-size: 12px;
	color: #999;
	display: block;
	margin-top: 2px;
}

.table th.border,
.table td.border {
	border-left: 2px solid #ddd;
}

</style>
